
import timeing from '@/components/alertPop/timeing.vue'
import { auyFun, sell } from '@/api'
import { mapActions, mapState } from 'vuex'
export default {
  name: "bigimgItem",
  props: {
    bigimgBol: {
      type: Boolean,
      default: false
    },
    bigimgArr: Array,
    adimg: ""

  },
  data () {
    return {
      selIndex: 0,//选中的side
      selArrindex: 0,//选中的item
      orderPoBol: false,
      adimg_pop: ""

    }
  },
  computed: {

  },
  destroyed () {
  },
  created () {

  },
  mounted () {

  },
  watch: {
    bigimgBol: {
      handler (newV, oldV) {
        this.adimg_pop = this.adimg
      },
    },
    adimg: {
      handler (newV, oldV) {
        if (newV) {

          this.selArrindex = 0
          this.bigimgArr.forEach((j, k) => {
            if (j.img_url == newV) {
              // this.selIndex = newV

              // this.selArrindex = Math.ceil(k / 8) - 1
              if (k > 8) {
                this.selIndex = k - 8
              } else {
                this.selIndex = k
              }
              // this.pinlunData = j

            }
          })
        }
      },
    }
  },
  methods: {
    bigimgBoladmin (img, selIndex) {
      this.selIndex = selIndex
      if (this.bigimgArr[this.selArrindex * 8 + selIndex].img_url) {
        this.adimg_pop = this.bigimgArr[this.selArrindex * 8 + selIndex].img_url
      } else {
        this.adimg_pop = this.bigimgArr[this.selArrindex * 8 + selIndex]
      }

    },
    // 轮播图滑动事件
    slideChange (index) {
      this.selIndex = 0
      this.selArrindex = index
      this.adimg_pop = this.bigimgArr[index * 8].img_url

    },
    handleClose () {
      this.selIndex = 0//选中的side
      this.selArrindex = 0//选中的item
      this.$emit('closeBIGIMG')
      // sessionStorage.setItem('coupon_bol', 1)
      // this.visible = false
    },

    Changeto () {
      this.chectBol = true
    },
    check () {
      this.visible = !this.visible
    },
    toaddress () {
      this.$router.push({
        path: '/address/2'
      })
    },
    tologin () {
      this.$router.push({
        path: '/login',
        query: { redirect: this.$router.currentRoute.fullPath }
      })
    }
  },
  beforeDestroy () {
    // clearInterval(this.timer); // 组件销毁前清除定时器
  },
  components: { timeing }
}
